import axios from '../http';

class Customer {
  static login(data) {
    const url = `/oa/api/pc/customer/login`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 拦截单查询 */
  static getInterceptOrderCodeSearch(code) {
    const url = `/oa/api/order/detail?code=${code}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 拦截单列表 */
  static getInterceptOrderCodeList(pageNo, code, beginDate, endDate, status) {
    const url = `/oa/api/intercept/order/customer/list?pageNo=${pageNo}&code=${code}&beginDate=${beginDate}&endDate=${endDate}&status=${status}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 发起拦截 */
  static postIntercept(data) {
    const url = "/oa/api/intercept/order/customer/save";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 制单 */
  static postVoucherPreparation(data) {
    const url = "/oa/api/intercept/order/customer/making";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Customer